import React, { useEffect } from "react";
import Image from "components/image";
import insertScript from "helpers/insert-script";
import { formatTitle } from "helpers/format-title";

const JobPosting = ({ data }) => {
	useEffect(() => {
		const src =
			// eslint-disable-next-line max-len
			"https://join.com/api/widget/bundle/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXR0aW5ncyI6eyJzaG93Q2F0ZWdvcnlGaWx0ZXIiOnRydWUsInNob3dMb2NhdGlvbkZpbHRlciI6dHJ1ZSwic2hvd0VtcGxveW1lbnRUeXBlRmlsdGVyIjp0cnVlLCJsYW5ndWFnZSI6ImRlIiwiam9ic1BlclBhZ2UiOjI1fSwiam9icyI6e30sImRlc2lnbiI6eyJzaG93TG9nbyI6dHJ1ZSwic2hvd0xvY2F0aW9uIjp0cnVlLCJzaG93RW1wbG95bWVudFR5cGUiOnRydWUsInNob3dDYXRlZ29yeSI6dHJ1ZSwiY29sb3JzIjp7IndpZGdldCI6eyJiYWNrZ3JvdW5kIjoiI0ZGRkZGRiIsImZpbHRlckJvcmRlciI6IiNEMEQ0REEiLCJwYWdpbmF0aW9uIjoiIzJBNzNGRiJ9LCJqb2JDYXJkIjp7InNoYWRvdyI6IiNEMEQ0REEiLCJiYWNrZ3JvdW5kIjoiI0ZGRkZGRiIsInByaW1hcnlUZXh0IjoiIzM2M0Y0QSIsInNlY29uZGFyeVRleHQiOiIjNUY2ODc1In19fSwidmVyc2lvbiI6MiwiY29tcGFueVB1YmxpY0lkIjoiMWE1MmE0OTczODkwMDBjNDk0NjA2ZTM1YmI4ZTI1ZTkiLCJpYXQiOjE2MTkwMDYyOTEsImp0aSI6Ijg5NzM3MGNhLTdlYjktNDk2MS1hMzA3LWU2MzRmMzI2NjAwOSJ9.nciobUuQUH-8yZxPMnZFPoHtffP8zOg28Buu6edNrlw";

		insertScript("body", src, false, true);
	}, []);

	return (
		<>
			<h1 className="text-center my-8 w-3/5 md:w-full mx-auto">{formatTitle(data.title)}</h1>
			<Image className="w-full h-full md:h-screen" image={data?.image} alt={data?.image?.alt} />

			<div className="w-full md:w-11/12 m-auto">
				<div id="join-widget"></div>
			</div>
		</>
	);
};

export default JobPosting;
